<div *ngIf="!isLoading  else loading">
	<p class="para-intro" translate>add-user.intro</p>
	<div class="matching-users" *ngIf="matchingUsers && matchingUsers.length !== 0">
		<p class="para-text" translate>add-user.matchin-users-intro</p>
		<mat-error *ngIf="nextClicked && !isAnyOneSelected" translate>add-user.please-select</mat-error>
		<mat-error *ngIf="nextClicked && currentSelectedUser && !isActive" translate>add-user.user-not-active</mat-error>
		<mat-error *ngIf="nextClicked && currentSelectedUser && userAlreadyExist" translate>add-user.user-exists</mat-error>
		<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridOptions" [modules]="modules" [rowData]="matchingUsers" (gridReady)="onGridReady($event)"></ag-grid-angular>
	</div>
	<div class="matching-users" *ngIf="!isLoading && (!matchingUsers || matchingUsers.length === 0)">
		<p class="para-text" translate>add-user.new-user-intro</p>
		<mat-error *ngIf="nextClicked && !isAnyOneSelected" translate>add-user.please-select</mat-error>
		<mat-error *ngIf="nextClicked && emailIdExist && isNewUser" translate>add-user.email-exist</mat-error>
		<ag-grid-angular class="ag-theme-balham" [gridOptions]="newUserGridOptions" [modules]="modules" [rowData]="newUserRowData" (gridReady)="onNewGridReady($event)"></ag-grid-angular>
	</div>
</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>